import { UserRole } from '../user-role';

import { UserBaseFormControls } from './user-base.form';
import { UserTraderForm } from './user-trader.form';

export class UserOperatorForm extends UserTraderForm {
    override role = UserRole.Operator;

    constructor() {
        super();
    }

    override initForm(): void {
        super.initForm();
        this.form.get(UserBaseFormControls.Role)?.setValue(UserRole.Operator, { emitEvent: false });
    }
}
